import { __decorate, __metadata } from "tslib";
import { Serialize, Type } from '@ftr/serialization';
import { ZonedDateTime } from '@js-joda/core';
import { HearingSegment } from '../../type/court';
import { Location } from '../location';
import { Turnaround } from '../transcript-turnaround';
/**
 * A transcription job
 */
export class Job {
}
__decorate([
    Serialize(),
    __metadata("design:type", ZonedDateTime
    /**
     * When the transcript is due by
     */
    )
], Job.prototype, "dueBy", void 0);
__decorate([
    Serialize(),
    __metadata("design:type", ZonedDateTime
    /**
     * The segments of the hearing to be transcribed
     * @deprecated Use lineItem.hearingSegments where possible
     */
    )
], Job.prototype, "transcriptDueBy", void 0);
__decorate([
    Type(() => HearingSegment),
    __metadata("design:type", Array)
], Job.prototype, "hearingSegments", void 0);
__decorate([
    Type(() => Turnaround),
    __metadata("design:type", Object)
], Job.prototype, "turnaround", void 0);
__decorate([
    Type(() => Location),
    __metadata("design:type", Object)
], Job.prototype, "location", void 0);
__decorate([
    Serialize(() => ZonedDateTime),
    __metadata("design:type", Object)
], Job.prototype, "assignedOn", void 0);
